//@ts-check
import validator from './validator';
var windowsInvalidPathChars = ['"', '<', '>', '|', '\0', "\x07", //BEL character
'\b', '\t', '\n', '\v', '\f', '\r', "\x01", "\x02", "\x03", "\x04", "\x05", "\x06", "\x0E", "\x0F", "\x10", "\x11", "\x12", "\x13", "\x14", "\x15", "\x16", "\x17", "\x18", "\x19", "\x1A", "\x1B", "\x1C", "\x1D", "\x1E", "\x1F"];
var fileNameInvalidChars = ['<', '>', ':', '"', '/', '\\', '|', '?', '*'];
/** This characters are not fully supported (e.g., breaks file preview) */

var unsupportedChars = ['%', '#', '+', '!', '$', '^', '(', ')', ';', "\xBC", "\xBD", "\xBE", "\u2150", "\u2151", "\u2152", "\u2153", "\u2154", "\u2155", "\u2156", "\u2157", "\u2158", "\u2159", "\u215A", "\u215B", "\u215C", "\u215D", "\u215E", "\u215F", "\u2189", "\u2070", "\xB9", "\xB2", "\xB3", "\u2074", "\u2075", "\u2076", "\u2077", "\u2078", "\u2079", "\u207A", "\u207B"];
var fileLabelInvalidChars = windowsInvalidPathChars.concat(fileNameInvalidChars).concat(unsupportedChars);
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = validator.shouldBeSpecified(value, 'Label name');
  if (error) return error;
  error = validator.shouldHaveMaxLength(value, 128);
  if (error) return error;
  error = validator.shouldNotContainChars(value, fileLabelInvalidChars);
  if (error) return error;
  return undefined;
});